import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as acts from "../../../redux/pre_processor/actions";
import { useDispatch, useSelector } from "react-redux";
import ProgressBar from "../../../components/ProgressBar";
import { Document, Page } from "react-pdf";
// import FileViewer from "react-file-viewer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import XlsxCsvViewer from "../../administrator/ExcelOutPut/xlsxViewer";

export const FilesPreview = ({
  openFilePreview,
  closeFilePreview,
  filePath,
}) => {
  const dispatch = useDispatch();

  const ipOpFileUrlForPreview = useSelector(
    (state) => state?.prePro?.ipOpFileUrlForPreview
  );
  const apiStatus = useSelector((state) => state?.prePro?.apiStatus);

  const [previewSrc, setPreviewSrc] = useState("");
  const [fileType, setFileType] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    setPreviewSrc("");
    setFileType("");
    setPageNumber(1);
    setNumPages(null);

    if (filePath) {
      dispatch(acts.getFileForPreview(filePath));
    }
  }, [dispatch, filePath]);
  useEffect(() => {
    if (ipOpFileUrlForPreview && typeof ipOpFileUrlForPreview === "object") {
      const values = Object.values(ipOpFileUrlForPreview);
      if (values.length > 0 && typeof values[0] === "string") {
        const fileUrl = values[0];
        const fileExt = fileUrl.split(".").pop().toLowerCase();
        setFileType(fileExt);
        setPreviewSrc(fileUrl);
      }
    }
  }, [ipOpFileUrlForPreview]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const closeDialog = () => {
    closeFilePreview();
    dispatch(acts.clearFileForPreview());
  };

  const renderViewer = () => {
    if (!previewSrc) return "No File";

    if (fileType === "xlsx" || fileType === "csv") {
      return (
        <div className="xlsx-fileViewer">
          {/* <FileViewer
            fileType={fileType}
            filePath={previewSrc}
            errorComponent={<div>Error loading file</div>}
          /> */}

          <XlsxCsvViewer filePath={previewSrc} />
        </div>
      );
    }

    return (
      <div>
        <Box className="pagination">
          <div className="p-sticky">
            <label className="paginationLabel">Page {pageNumber}</label>
            <IconButton
              aria-label="left"
              onClick={() => pageNumber > 1 && setPageNumber(pageNumber - 1)}
              disabled={pageNumber === 1}
            >
              <ChevronLeftIcon />
            </IconButton>
            <IconButton
              aria-label="right"
              onClick={() => setPageNumber(pageNumber + 1)}
              disabled={pageNumber === numPages}
            >
              <ChevronRightIcon />
            </IconButton>
          </div>
        </Box>
        <Box style={{ padding: "35px 0px" }}>
          <Document
            file={previewSrc}
            onLoadSuccess={onDocumentLoadSuccess}
            renderMode="canvas"
            className="custom-pdf-document"
          >
            <Page pageNumber={pageNumber} />
          </Document>
        </Box>
      </div>
    );
  };

  return (
    <Dialog
      open={openFilePreview}
      onClose={() => closeDialog()}
      fullWidth
      maxWidth={false}
      PaperProps={{
        style: {
          width: "95vw",
          height: "95vh",
          maxWidth: "95vw",
          maxHeight: "95vh",
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: "10px 0px 10px 30px" }}>
        Preview File
        <IconButton
          aria-label="close"
          onClick={() => closeDialog()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        <Box className="xlsx-wrap-fullheight">
          {apiStatus?.loader ? <ProgressBar /> : renderViewer()}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
